// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0001 2.09155V22.7897L3.17212 13.0494L19.0001 2.09155Z"}}]};

const DeltaFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'delta-filled',
    ref,
    icon: element,
  },
));

DeltaFilledIcon.displayName = 'DeltaFilledIcon';

export default DeltaFilledIcon;
